import { Routes, Route, Navigate } from "react-router-dom";
import RootLayout from "../shared/components/RootLayout";
import Error from "../shared/components/Error";
import HomeDefault from "../pages/home/HomeDefault";
import ArticlePage from "../pages/articles/ArticlePage";
import ArticleEditor from "../pages/account/creator/ArticleEditor";

// Auth routes
import Login from "../pages/auth/Login";
import Register from "../pages/auth/Register";
import VerifyEmail from "../pages/auth/VerifyEmail";

// Auth guards
import ProtectedRoute from "../shared/auth/ProtectedRoute"; // ล็อกอินพอ
import ProtectedRouteVerified from "../shared/auth/ProtectedRouteVerified"; // ต้อง verified
import ProtectedRouteGuest from "../shared/auth/ProtectedRouteGuest"; // ยังไม่ล็อกอินเท่านั้น
import Profile from "../pages/account/Profile";
import AccountLayout from "../pages/account/AccountLayout";
import Overview from "../pages/account/Overview";
import Security from "../pages/account/Security";
import Purchases from "../pages/account/Purchases";
import Billing from "../pages/account/Billing";
import Notifications from "../pages/account/Notifications";
import MyArticles from "../pages/account/creator/MyArticle";
import BookmarkArticle from "../pages/account/articles/BookmarkArticle";
import SearchResultPage from "../pages/search/SearchResultPage";
import UserInformation from "../pages/account/admin/UserInformation";
import TermsOfService from "../pages/info/TermsOfService";
import PrivacyPolicy from "../pages/info/PrivacyPolicy";
import AboutUs from "../pages/info/AboutUs";
import ContactUs from "../pages/info/ContactUs";
import EnChatInfo from "../pages/info/EnChatInfo";
import ContactMessages from "../pages/account/admin/ContactMessages";
import ImageGuidelinePage from "../pages/info/ImageGuidelinePage";

import CourseDetailPage from "../pages/courses/CourseDetailPage";
import CourseEnrollPage from "../pages/courses/CourseEnrollPage";
import CoursePlayerPage from "../pages/courses/CoursePlayerPage";

export default function AppRouter() {
  return (
    <Routes>
      <Route element={<RootLayout />}>
        {/* สาธารณะ */}
        <Route path="/" element={<HomeDefault />} />
        <Route path="/articles/:slug" element={<ArticlePage />} />
        <Route path="/search" element={<SearchResultPage />} />

         {/* Info Pages (Static Pages) */}
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/enchat" element={<EnChatInfo />} />

         {/* Course MockUp */}
        <Route path="/courses/:slug" element={<CourseDetailPage />} />
        <Route path="/courses/:courseId/enroll" element={<ProtectedRoute><CourseEnrollPage /></ProtectedRoute>} />
        <Route path="/learn/:courseId" element={<ProtectedRoute><CoursePlayerPage /></ProtectedRoute>} />
        

        {/* Guest routes */}
    {/*     <Route
          path="/login"
          element={
            <ProtectedRouteGuest>
              <Login />
            </ProtectedRouteGuest>
          }
        /> */}
        {/* <Route
          path="/register"
          element={
            <ProtectedRouteGuest>
              <Register />
            </ProtectedRouteGuest>
          }
        /> */}

        {/* ต้องล็อกอิน (แต่ยังไม่ต้อง verified) */}
        <Route
          path="/verify-email"
          element={
            <ProtectedRoute>
              <VerifyEmail />
            </ProtectedRoute>
          }
        />

        {/* account zone (ล็อกอินพอ) */}
        {/* <Route path="/account" element={<ProtectedRoute><AccountLayout/></ProtectedRoute>}> */}
          {/* <Route index element={<Overview/>} /> */}
          {/* <Route path="profile" element={<Profile/>} />          */}
          {/* <Route path="security" element={<Security/>} />
          <Route path="purchases" element={<Purchases/>} />
          <Route path="billing" element={<Billing/>} /> */}
      {/*     <Route path="notifications" element={<Notifications/>} />

          <Route path="bookmarks" element={<BookmarkArticle/>} /> */}

          {/* ต้องล็อกอินและ verified แล้วเท่านั้น */}
         {/*  <Route path="creator/MyArticle" element={<ProtectedRouteVerified><MyArticles /></ProtectedRouteVerified>}/>
          <Route path="creator/ImageGuidelinePage" element={<ProtectedRouteVerified><ImageGuidelinePage /></ProtectedRouteVerified>}/> */}

          {/* <Route path="admin/UserInformation" element={<ProtectedRouteVerified><UserInformation /></ProtectedRouteVerified>}/> */}
          {/* <Route path="admin/ContactMessages" element={<ProtectedRouteVerified><ContactMessages /></ProtectedRouteVerified>}/> */}
          
        {/* </Route> */}

       {/*  <Route path="/account/creator/ArticleEditor/:articleId" element={<ProtectedRouteVerified><ArticleEditor /></ProtectedRouteVerified>}/> */}

        {/* ✅ หน้าโปรไฟล์ (ล็อกอินแล้วเท่านั้น) */}
        {/* <Route
          path="/account/profile"
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        /> */}

        {/* ต้องล็อกอินและ verified แล้วเท่านั้น */}
     {/*    <Route path="/account/creator/ArticleEditor"
          element={
            <ProtectedRouteVerified>
              <ArticleEditor />
            </ProtectedRouteVerified>
          }
        /> */}
       

    
        

        {/* ต้องล็อกอินและ verified แล้วเท่านั้น */}
        {/* <Route path="/account/creator/ArticleEditor"
          element={
            <ProtectedRouteVerified>
              <ArticleEditor />
            </ProtectedRouteVerified>
          }
        /> */}
        

        {/* fallback */}
        <Route path="*" element={<Error />} />
      </Route>
    </Routes>
  );
}
